import { combineReducers } from 'redux';

import user from './user';
import notifications from './notifications';
import payments from './payments';
import paulChat from './paulChat';
import newCourse from './newCourse';
import alert from './alert';
import onboarding from './onboarding';
import installments from './payments/installments';
import plan from './payments/plan'
import coupon from './payments/coupon';

export default combineReducers({
  user,
  notifications,
  payments,
  paulChat,
  alert,
  onboarding,
  newCourse,
  installments,
  coupon,
  plan
});
